import type { QueryClient, QueryKey } from '@tanstack/react-query';

export const REVIEW_DECISION_REFRESH_MS = 300;
const batches = new WeakMap<QueryClient, { keys: Map<string, QueryKey>; timer: ReturnType<typeof setTimeout> }>();

/** Coalesce rapid decisions without extending the delay indefinitely. No refetch blocks a saved decision. */
export function scheduleReviewRefresh(client: QueryClient, keys: QueryKey[]): void {
    let batch = batches.get(client);
    if (!batch) {
        batch = { keys: new Map(), timer: setTimeout(() => {
            const pending = batches.get(client);
            batches.delete(client);
            for (const key of pending?.keys.values() ?? []) {
                void client.invalidateQueries({ queryKey: key }).catch((error) => {
                    console.error('[Review] Background refresh failed', error);
                });
            }
        }, REVIEW_DECISION_REFRESH_MS) };
        batches.set(client, batch);
    }
    for (const key of keys) batch.keys.set(JSON.stringify(key), key);
}
